import React from 'react';
import './Componenst.css';
import ProceedingsModel from '../models/ProceedingsModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createProceedings, showError } from '../ViewCreator';

function Proceedings({ changeSearch, searchModel, setView, addNew = () => {}, isAdd = false }) {

    const personModel = new ProceedingsModel();


    const clearSubmit = () => {
        document.getElementById('fabulaProceedings').value     = '';
    document.getElementById('dateProceedings').value     = '';
    document.getElementById('numberProceedings').value     = '';
    document.getElementById('typeProceedings').value     = '';
    personModel.fabulaProceedings = ''
    personModel.dateProceedings = ''
    personModel.numberProceedings = ''
    personModel.typeProceedings = ''
    if (searchModel != undefined ) {
      searchModel.proceedings.fabulaProceedings = ''
      searchModel.proceedings.dateProceedings = ''
      searchModel.proceedings.numberProceedings = ''
      searchModel.proceedings.typeProceedings = ''
    }
    }

    const addSubmit = () => {
        if (personModel.typeProceedings == undefined || personModel.tytypeProceedingspeGun == '') {
            showError('Тип не може бути пустим')
            return;
        }

        if (personModel.numberProceedings == undefined || personModel.numberProceedings == '') {
            showError('Номер не може бути пустим')
            return;
        }

        if (personModel.dateProceedings == undefined || personModel.dateProceedings == '') {
            showError('Дата не може бути пустою')
            return;
        }

          isUniq()
    }

    const isUniq = () => {
        var path = ip + '/api/proceedings/search';
        personModel.searchModel = new SearchModel()
        var pp = new ProceedingsModel();
        pp.dateProceedings = personModel.dateProceedings
        pp.numberProceedings = personModel.numberProceedings
        pp.typeProceedings = personModel.typeProceedings
        var bd = encryptAes(JSON.stringify(pp))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
    
              if (result.data.length > 0) {
                Swal.fire({
                    title: 'Запис уже існує',
                    //text: "Оновити інформацію?",
                    icon: 'warning',
                    html:
                    'Запис з такими даними вже існує, Ви можете ' +
                    '<a href="/proceedings?id='+result.data[0].id+'" style="color:#FFFFFF;"  target="_blank">переглянути запис</a>',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: 'ОК',
                      denyButtonText: 'Оновити',
                      background: '#2B2B2B',
                      color: '#FFF'
                    }).then((result) => {
                    })
                  sendSearch()
              } else {
                Swal.fire({
                  title: 'Ви дійсно бажаєте створити новий запис',
                  //text: "Оновити інформацію?",
                  icon: 'question',
                  html:
                  '',
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: 'Створити',
                  denyButtonText: 'Оновити',
    
                  background: '#2B2B2B',
                  color: '#FFF'
                }).then((result) => {
                  addNewProc()
                  })
                
              }
            }
          })
      }

      const addNewProc = () => {
        var path = ip + '/api/proceedings/add';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
              
    
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
              if (isAdd) {
                addNew(result.data, 20007)
                clearSubmit()
              } else {
              window.open("/edit/proceedings?id="+result.data, "_self")
              }
            }
          })
      }

    const sendProceedingsFullScreen = (id) => {
        window.open("/proceedings?id=" + id)
    }

    const sendProceedings = (id) => {
        var path = ip + '/api/proceedings/id';
       var bd = encryptAes(id)
           const requestOptions = {
             headers: {
               'Content-Type': 'Content-type: text/html; charset=win1251'
             },
             credentials: 'include',
             uri: path,
             encoding: 'latin1',
             body: bd,
             method: 'POST'
           };
           fetch(path, requestOptions)
           .then()
           .then(response => { return response.arrayBuffer() })
           .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []
                
                    var addr = result.data
                    
                    zz.push(createProceedings(addr))

                    setView(zz)
                }
            })
    }


    const handleSubmit = (e) => {
        sendSearch();
        e.preventDefault();
    }

    const sendSearch = () => {
        var path = ip + '/api/proceedings/search';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []

                    for (let index = 0; index < result.data.length; index++) {
                        var z = document.createElement('div'); // is a node
                        var pers = result.data[index]
                        var i = pers.id
                        z.className = "listItem"
                        z.innerHTML = "<p align=\"left\">"+pers.typeProceedings + " "+ pers.numberProceedings + "<br>" + pers.dateProceedings + (pers.fabulaProceedings != undefined ? "<br>"+ pers.fabulaProceedings : "");
                        z.style.display = "block";
                        const cl = i => () => {
                            sendProceedings(i)
                        }
                        const dblcl = i => () => {
                            sendProceedingsFullScreen(i)
                        }
                        //z.onclick = cl(pers.id)
                        z.ondblclick = dblcl(pers.id)
                        var per = new ProceedingsModel()
                        per.id = pers.id
                        z.value = per
                        zz.push(z);
                    }
                    changeSearch(zz)
                }
            })
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }
    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id)
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "List").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "List").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id).value = l[index]
                            document.getElementById(id + "List").innerHTML = "";

                           
                              if(id=='typeProceedings'){
                                personModel.typeProceedings = l[index]
                              }
                              if(id=='numberProceedings'){
                                personModel.numberProceedings = l[index]
                              }
                              if(id=='dateProceedings'){
                                personModel.dateProceedings = l[index]
                              }
                              if(id=='fabulaProceedings'){
                                personModel.fabulaProceedings = l[index]
                              }

                        }
                        document.getElementById(id + "List").appendChild(z);

                    }
                }
            })








    }


      const typeProceedingschange = () =>  {
        personModel.typeProceedings = document.getElementById('typeProceedings').value
        changedfield('typeProceedings');
      }
    
      const numberProceedingschange = () =>  {
        personModel.numberProceedings = document.getElementById('numberProceedings').value
        changedfield('numberProceedings');
      }
    
      const dateProceedingschange = () =>  {
        personModel.dateProceedings = document.getElementById('dateProceedings').value
        changedfield('dateProceedings');
      }
    
      const fabulaProceedingschange = () =>  {
        personModel.fabulaProceedings = document.getElementById('fabulaProceedings').value
        changedfield('fabulaProceedings');
      }


    const handleFocus = (event) => {
        closeAllHelp()
    };

    return (
        <div>
            <button id="clear-button-proceedings" className="clear-button-right" onClick={clearSubmit}>Очистити
            </button>
            <button id="add-button-proceedings" className="add-button-right" onClick={addSubmit}>Додати
            </button>
            <form onSubmit={handleSubmit} className="form">
                <input id="input-button-proceedings" className="input-button-right" type="submit" value="Пошук" />

          <div id="fabulaProceedingsDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="fabulaProceedings" className="input-text" tabIndex="4" name="login" type="text" onChange={fabulaProceedingschange}  placeholder="Фабула" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="fabulaProceedingsList" className="list" />
          </div>

          <div id="dateProceedingsDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="dateProceedings" className="input-text" tabIndex="3" name="login" type="text" onChange={dateProceedingschange}  placeholder="Дата" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}   />
            <div id="dateProceedingsList" className="list" />
          </div>

          <div id="numberProceedingsDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="numberProceedings" className="input-text" tabIndex="2" name="login" type="text" onChange={numberProceedingschange}  placeholder="Номер" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="numberProceedingsList" className="list" />
          </div>

          <div id="typeProceedingsDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="typeProceedings" className="input-text" tabIndex="1" name="login" type="text" onChange={typeProceedingschange}  placeholder="Тип справи" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}  />
            <div id="typeProceedingsList" className="list" />
          </div>
          



            </form>
        </div>
    );
}

export default Proceedings;